import React from 'react'
import ButtonStyle from '../styles/ButtonStyle'

const Button = ({ link, title }) => {
  return (
    <ButtonStyle style={{ marginLeft: 'auto', marginRight: 'auto' }}>
      <a className="btn" href={link}>
        {title}
      </a>
    </ButtonStyle>
  )
}

export default Button
